import * as service from './base';

const base_endpoint = `/api/cms/`;

export async function getCategoriesWithFilter(id, filter) {
    const url = `${base_endpoint}${id}/categories?filter=${filter}`
    return await service.get(url);
}
